<script setup>

import AccountUnitAnalystAudit from "./accountUnitAnalystAudit.vue";
import AccountUnitUploadInventoryHandStatusAudit from "./accountUnitUploadInventoryHandStatusAudit.vue";
import AccountUnitWriteFinishStatusAudit from "./accountUnitWriteFinishStatusAudit.vue";
import AccountUnitWritePermanentSolutionAudit from "./accountUnitWritePermanentSolutionAudit.vue";
import AfterSalesMinisterAudit from "./afterSalesMinisterAudit.vue";
import MarketEngineerAudit from "./marketEngineerAudit.vue";
import MarketingManagerAudit from "./marketingManagerAudit.vue";
import NormalAudit from "./normalAudit.vue";
import PdiEngineerUploadPdiResultAudit from "./pdiEngineerUploadPdiResultAudit.vue";
import QeAssignAccountUnitAudit from "./qeAssignAccountUnitAudit.vue";
import QeCheckAndUploadBreakPointInfoAudit from "./qeCheckAndUploadBreakPointInfoAudit.vue";
import QeEnsurePermanentSolutionAudit from "./qeEnsurePermanentSolutionAudit.vue";
import QeReasonAnalystAudit from "./qeReasonAnalystAudit.vue";
import QeVehicleDisposalPlanForTheOutputMarketAudit from "./qeVehicleDisposalPlanForTheOutputMarketAudit.vue";
import QualityEngineerCloseAudit from "./qualityEngineerCloseAudit.vue";
import QualityManagerInitiateRecallAudit from "./qualityManagerInitiateRecallAudit.vue";
import QualityReasonAnalystAudit from "./qualityReasonAnalystAudit.vue";
import ReasonAnalystAudit from "./reasonAnalystAudit.vue";
import SolutionAudit from "./solutionAudit.vue";
import QualityManagerUpgradeAudit from "./qualityManagerUpgradeAudit.vue";
import ManagerSubmit from "./managerSubmit.vue";
</script>

<template>
    <div class="audit-form-main">
        <account-unit-analyst-audit  :taskId="taskId" v-if="taskDefKey === 'accountUnitAnalystAudit'"></account-unit-analyst-audit>

        <account-unit-upload-inventory-hand-status-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :marketVehicles="marketVehicles"
                                                         v-if="taskDefKey === 'Activity_16fs05f'">
        </account-unit-upload-inventory-hand-status-audit>

        <account-unit-write-finish-status-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :receivedForm="receivedForm"
                                                v-if="taskDefKey === 'Activity_160anpw'"></account-unit-write-finish-status-audit>

        <account-unit-write-permanent-solution-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :receivedForm="receivedForm"
                                                     v-if="taskDefKey === 'Activity_0urc73r' ">
        </account-unit-write-permanent-solution-audit> <!--  责任单位填写永久方案和计划改善时间-->

        <after-sales-minister-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :suggestionItems="suggestionItems"
                                    v-if="taskDefKey === 'Activity_1wqnwvf'"></after-sales-minister-audit> <!--  售后服务部部长审核-->


        <market-engineer-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :suggestionItems="suggestionItems"
                               v-if="taskDefKey === 'Activity_1a7qzv5' ||
                                taskDefKey === 'Activity_0g2kdpo' ||
                                taskDefKey === 'Activity_11t4h10' ">
        </market-engineer-audit> <!--  市场工程师审核永久方案 断点时间-->

        <marketing-manager-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :countryDataId="countryDataId"
                                 v-if="taskDefKey === 'Activity_152lqau'"></marketing-manager-audit> <!--  市场工程师指定QE人员-->
        <normal-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey"
                      v-if="taskDefKey === 'Activity_0wh76h6' ||
                      taskDefKey === 'Activity_0vptm0p'">
        </normal-audit> <!--  经销商提交后服务经理审核   无临时措施后的质量经理审核-->

        <pdi-engineer-upload-pdi-result-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :suggestionItems="suggestionItems"
                                              :pdiMessage="pdiMessage"
                                              :pdiMessageFile="pdiMessageFile"
                                              v-if="taskDefKey === 'Activity_0ioza48'">
        </pdi-engineer-upload-pdi-result-audit> <!--  PDI工程师上传排查结果 -->

        <qe-assign-account-unit-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :suggestionItems="suggestionItems" :marketVehiclesList="marketVehiclesList"
                                      v-if="taskDefKey === 'Activity_0th0wyq' ||
                                      taskDefKey === 'Activity_0xqs0a8'">
        </qe-assign-account-unit-audit><!--  QE指定责任单位人员-->

        <qe-check-and-upload-break-point-info-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :suggestionItems="suggestionItems"
                                                    v-if="taskDefKey === 'Activity_1348h5u'"></qe-check-and-upload-break-point-info-audit> <!--  QE验证并上传断点信息-->

        <qe-ensure-permanent-solution-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :suggestionItems="suggestionItems"
                                            v-if="taskDefKey === 'Activity_0nw86wc'">
        </qe-ensure-permanent-solution-audit> <!--  QE审核永久方案-->

        <qe-reason-analyst-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :suggestionItems="suggestionItems"
                                 v-if="taskDefKey === 'Activity_18tjzgb'"></qe-reason-analyst-audit> <!--  QE审核根因分析-->

        <qe-vehicle-disposal-plan-for-the-output-market-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :marketVehicles="marketVehicles"
                                                              v-if="taskDefKey === 'Activity_06py48i' ||
                                                               taskDefKey === 'Activity_0ssx6ld' ||
                                                               taskDefKey === 'Activity_0zd71x8' ||
                                                               taskDefKey === 'Activity_119d7lh'">
        </qe-vehicle-disposal-plan-for-the-output-market-audit> <!--  QE输出市场车辆及库存车辆处置方案-->

        <quality-engineer-close-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :suggestionItems="suggestionItems"
                                      :pdiMessage="pdiMessage"
                                      :PDIcheck="PDIcheck"
                                      :pdiMessageFile="pdiMessageFile"
                                      :pdiCheckResult="pdiCheckResult"
                                      :pdiCheckResultFiles="pdiCheckResultFiles"
                                      v-if="taskDefKey === 'Activity_00kcjof'">
        </quality-engineer-close-audit> <!--  质量经理关闭流程-->

        <quality-manager-initiate-recall-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :marketVehicles="marketVehicles"
                                               v-if="taskDefKey === 'Activity_02i0f7v'">
        </quality-manager-initiate-recall-audit> <!--  质量经理发起召回流程-->

        <quality-reason-analyst-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :suggestionItems="suggestionItems" :endProcess= "endProcess"
                                      v-if="taskDefKey === 'Activity_070sjiw'"></quality-reason-analyst-audit> <!--  质量改善部部长审核根因分析材料-->

        <reason-analyst-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :reasonAnalystData="reasonAnalystData"
                              v-if="taskDefKey === 'Activity_18nq1e5' ||
                               taskDefKey === 'Activity_009xhan' ||
                               taskDefKey === 'Activity_0q3vnwm' ||
                               taskDefKey === 'Activity_0ataghk'">
        </reason-analyst-audit> <!--  责任单位判断是否差缺根因分析材料-->

        <solution-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :replenish= "replenish" :provisionalMeasures="provisionalMeasures"
                      v-if="taskDefKey === 'Activity_0cimoly' ||
                        taskDefKey === 'Activity_1k5zmes' ||
                        taskDefKey === 'Activity_1gdlabb' ||
                        taskDefKey === 'Activity_17t4hjg' ||
                        taskDefKey === 'Activity_1b6g0rq' ||
                        taskDefKey === 'Activity_1w71m0r' ||
                        taskDefKey === 'Activity_1ayglqh' ||
                        taskDefKey === 'Activity_0gsxnyt'
                         ">
        </solution-audit> <!--  技术经理判断是否有临时措施-->
        <quality-manager-upgrade-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :provisionalMeasures="provisionalMeasures" :pdiSub="pdiSub"
                                     v-if="taskDefKey === 'Activity_1jmu1ad'"></quality-manager-upgrade-audit>

      <manager-submit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey"
                                     v-if="taskDefKey === 'Activity_1r5u2c8' || taskDefKey === 'Activity_1lvb0jl'"></manager-submit> <!--  服务经理再次提交-->

    </div>
</template>

<style scoped lang="scss">

</style>
<script>
import {requestTaskDetail} from "../../api/feedback";

export default {
  name: "switchMainAudit",
  props: {
    taskId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
        taskDefKey: "",
        questionId: "",
        countryDataId: "",
        taskDetail:{
          taskId: ""
        },
      suggestionItems: [],
      marketVehiclesList: [],
      endProcess: false,
      pdiSub: false,
      pdiMessage: "",

      pdiCheckResult: "",
      replenish: false,
      provisionalMeasures: "",
      marketVehicles: {},
      reasonAnalystData: {},
      reconfirm: false,
      pdiCheckResultFiles: [],
      PDIcheck: false,
      pdiMessageFile: [],
      receivedForm: {
        reasonAnalystMaterial: "",
        reasonAnalyst: "",
        file:[]
      },
    }
  },
  components: {
  },
  methods: {
    loadTaskDetail(){
      let taskId = this.taskId;
      let searchParam = new URLSearchParams();
      searchParam.append("taskId", taskId)
      requestTaskDetail(searchParam).then(res => {
        if(res.status == "0"){
            this.taskDetail = res.data;
            this.taskDefKey = res.data.taskDefKey;
            this.questionId = res.data.variables.questionId;
            this.countryDataId = res.data.variables.countryDataId;
            if (this.taskDefKey == "Activity_18tjzgb" ||
              this.taskDefKey == "Activity_070sjiw" ||
              this.taskDefKey == "Activity_0nw86wc" ||
              this.taskDefKey == "Activity_1348h5u" ||
              this.taskDefKey == "Activity_0th0wyq" ||
              this.taskDefKey == "Activity_0xqs0a8" ||
              this.taskDefKey == "Activity_1a7qzv5" ||
              this.taskDefKey == "Activity_0g2kdpo" ||
              this.taskDefKey == "Activity_11t4h10" ||
              this.taskDefKey == "Activity_1wqnwvf" ||
              this.taskDefKey == "Activity_0ioza48" ||
              this.taskDefKey == "Activity_00kcjof"){ // 回填根音分析材料 断点时间 永久方案 等
              this.suggestionItems = res.data.variables.reasonAnalystDataList;
              if (res.data.variables.endProcess != null){
                this.endProcess = res.data.variables.endProcess;
              }
              if (res.data.variables.pdiMessage != null){
                this.pdiMessage = res.data.variables.pdiMessage;
                this.pdiMessageFile = res.data.variables.pdiMessageFile;
                this.PDIcheck = res.data.variables.PDIcheck;
              }
              if (res.data.variables.pdiCheckResult != null){
                this.pdiCheckResult = res.data.variables.pdiCheckResult;
                this.pdiCheckResultFiles = res.data.variables.pdiCheckResultFiles;
              }
              if (res.data.variables.marketVehiclesList != null){
                this.marketVehiclesList = res.data.variables.marketVehiclesList;
              }

            }
          // 如果是责任单位填写永久方案和计划改善时间，则每一个责任单位人员回填自己的根因分析材料
          if (this.taskDefKey == "Activity_0urc73r" || this.taskDefKey == "Activity_160anpw" ){
            this.receivedForm = res.data.variables.reasonAnalystDataList.find(item =>
              item.userId === res.data.startUserId
            ) || {};
          }
          // 补充临时措施标识
          if ( this.taskDefKey == "Activity_1k5zmes"){
            this.replenish = true;
          }
          // 临时措施回填
          if (this.taskDefKey == "Activity_1gdlabb" ||
            this.taskDefKey == "Activity_17t4hjg" ||
            this.taskDefKey == "Activity_1b6g0rq" ||
            this.taskDefKey == "Activity_1w71m0r" ||
            this.taskDefKey == "Activity_1jmu1ad" ||
            this.taskDefKey == "Activity_1ayglqh" ||
            this.taskDefKey == "Activity_0gsxnyt"){
            this.provisionalMeasures = res.data.variables.provisionalMeasures;
          }
          if (this.taskDefKey == "Activity_0ssx6ld" ||
            this.taskDefKey == "Activity_0zd71x8" ||
            this.taskDefKey == "Activity_119d7lh" ||
            this.taskDefKey == "Activity_02i0f7v" ||
            this.taskDefKey == "Activity_16fs05f"){ // 回填市场库存车辆处置方案
            this.marketVehicles = res.data.variables.marketVehicles;
          }
          if (this.taskDefKey == "Activity_009xhan" ||
            this.taskDefKey == "Activity_0q3vnwm" ||
            this.taskDefKey == "Activity_0ataghk"){// 回填缺失根因分析材料
            this.reasonAnalystData = res.data.variables.reasonAnalystData;
          }

          if (this.taskDefKey == "Activity_18nq1e5"){

            this.reasonAnalystData = res.data.variables.reasonAnalystDataList.find(item =>
              item.userId === res.data.startUserId
            ) || {};
            if (this.reasonAnalystData != {}){
              this.reconfirm = true;
            }
          }

          if (this.taskDefKey == "Activity_1jmu1ad" ){ // 质量经理驳回pdi提交
           this.pdiSub = res.data.variables.pdiSub
          }

        }else {
          this.$DonMessage.error(res.data.message);
        }
      })
    }
  },
  mounted() {
    console.log("switchMainAudit:"+this.taskId)
    this.loadTaskDetail();
  }
}
</script>
